import React from "react";
import PropTypes from "prop-types";
import withSnack from "./withSnack";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Hidden
} from "@material-ui/core/";
import IconButton from '@material-ui/core/IconButton/IconButton'
import CancelIcon from '@material-ui/icons/Cancel'
import UserStore from "../stores/UserStore";
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

export class Sessions extends React.Component {
  state = {
    devices: [],
  };

  componentDidMount(){
    UserStore.list_sessions(this.props.params.id).then(r => {
          this.setState({ devices: r.data });
        });
  }

  onClose = () => {
    this.props.onClose();
  };

  killSession = (id) => {
    UserStore.kill_session(this.props.id,id).then(r => {
      this.setState({ devices: r.data });
    })
    .catch((error) => {
        this.props.snack('Error al finalizar sesión', 'warning')
    })
  }

  render() {
    const { open } = this.props;
    const { devices } = this.state;

    let sessions = <Typography variant="body1" gutterBottom align="center">No hay sesiones</Typography>;
    if(devices.length > 0){
        sessions = (
          <React.Fragment>
          <Table padding="dense" spacing={0} align="nowrap">
            <TableHead>
              <TableRow>
                <TableCell>Dirección IP</TableCell>
                <Hidden smDown>
                  <TableCell>Navegador</TableCell>
                  <TableCell>Fecha/Hora de Inicio</TableCell>
                </Hidden>
                <TableCell>Estado</TableCell>
                <TableCell>Eliminar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {devices.map(d => {
              return (
                <TableRow key={d.device_id}>
                  <TableCell>{d.ip}</TableCell>
                  <Hidden smDown>
                    <TableCell>{d.device}</TableCell>
                    <TableCell>{d.started}</TableCell>
                  </Hidden>
                  <TableCell>{d.current? <strong>*</strong> : null}{d.active? 'Activa' : 'Inactiva'}</TableCell>
                  <TableCell>
                    {d.active?
                      (
                        <IconButton color="default" onClick={() => this.killSession(d.device_id)} disabled={d.current? true : false}>
                          <CancelIcon  />
                        </IconButton>
                      ) : null}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <Typography variant="caption" gutterBottom align="center">
          <strong>*Sesión actual</strong>
        </Typography>
      </React.Fragment>);
    }

    return (
      <Dialog aria-labelledby="Sessions" open={open}>
        <DialogTitle style={{textAlign: 'center'}}>Historial de sesiones
          <IconButton onClick={this.onClose} className="close_fix_button" >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent style={{paddingBottom: "10px"}} className="modal_sessions">
          {sessions}
        </DialogContent>
      </Dialog>
    );
  }
}

Sessions.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default withSnack(Sessions);



// WEBPACK FOOTER //
// ./src/components/ListSessions.js